import { css } from '@emotion/react';
import theme from 'shared/styles/themes';

export default css({
  '&.creator-brief-starting-steps': {
    '& .checkbox-group, & .address-form-fields, & .creator-brief-starting-steps__pitch': {
      padding: `0 ${theme.space[5]}`,
    },
    '& strong': {
      fontWeight: 600,
    },
  },
  '.creator-brief-starting-steps': {
    '&__li': {
      marginBottom: theme.space[4],
    },
    '&__pitch__subheading': {
      padding: '0 1rem',
      whiteSpace: 'pre-wrap',
      lineHeight: '1.2',
      fontSize: theme.fontSizes[2],
    },
    '&__states-wrapper': {
      flexDirection: 'column',
      alignItems: 'center',
      padding: `0 ${theme.space[7]}`,
    },
    '&__states': {
      paddingBottom: theme.space[5],
    },
    '&__pitch__hr': {
      margin: `0 ${theme.space[5]} ${theme.space[4]} ${theme.space[5]}`,
      width: `calc(100% - (${theme.space[5]} * 2))`,
    },
    '&__shipping__subheading': {
      textAlign: 'center',
      whiteSpace: 'pre-line',
    },
    '&__states-subheading': {
      marginBottom: theme.space[4],
      textAlign: 'center',
    },
    '&__confirmation-text': {
      padding: `0 ${theme.space[7]}`,
    },
  },
});
